// Lean-UI switches for the 29 Sep trade fair. Nothing behind a switch is
// deleted — flipping it back to true brings the screen or affordance back.

// Hides the Developers page, its links (Footer, account menu, console) and
// the API keys tab in Manage workspace. Flip to true to bring it all back.
export const SHOW_DEVELOPER_API = false;

// Structure maps: "Open map" and the "structure" choice in the diagram
// format switcher. On (decided 22 Sep 2026); false hides them.
export const SHOW_MAPS = true;

// Plans in the customer-facing UI (product owner, 28 Sep 2026: "forget about
// our subscriptions, as we will be controlling the content from views").
// What a reader is looking at is the workspace, the library and the view -
// the plan is a billing matter between bpExperts and the customer.
//
// False hides: the plan chip in the account menu and on My account, the plan
// name and "Upgrade plan" / "Talk to us about upgrading", and every place a
// reader would meet a plan name (see the two labels below). It does NOT
// touch the admin console's Plans and entitlements, a workspace's Plan tab,
// or any entitlement: editing, FlowOS, exports and the API still read them.
//
// It hides the **trial** with them (28 Sep 2026). Plans decide nothing now,
// so "N days left in your trial", "Access until ...", the Trial and Expired
// chips and "Request more time" promised an ending that never comes and
// offered a request for time nobody was taking away. Gone from Home, My
// account and the sign-in page; bpExperts' own screens (All users, Admin
// overview, a workspace's Plan tab) still show trial state, because that is
// where it is still true.
//
// When a workspace is given an explicit "access until" date of its own
// (docs/superpowers/plans/2026-09-28-retiring-subscriptions.md), **that** is
// what a reader should be told - not a plan's trial. The seam is the same
// line on Home and on My account.
export const SHOW_PLANS = false;

// Where something isn't the reader's to open or to take, and the reason is
// the plan behind the scenes: with plans out of the UI we say what it means
// for them instead of naming a plan they have never been shown.
export const LOCKED_LABEL = SHOW_PLANS ? "Not in your plan" : "Not available to you";
export const DOWNLOAD_LOCKED = SHOW_PLANS ? "Downloads are included in Ultimate Plus" : "Downloads aren't available to you";
export const LOCKED_NOTICE = SHOW_PLANS ? "This content is not available in your plan." : "This content isn't available to you.";
